const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useCounter, useProgress } =
    window.PURELEI.Carousel.plugins

class TeamCarousel extends window.PURELEI.CustomElement() {
    connectedCallback () {
        super.connectedCallback()

        this.carousel = this.setupCarousel()
    }

    setupListeners () {
        super.setupListeners()
    }

    setupCarousel () {
        return new KeenSlider(
            this.els.slides.element,
            {
                selector: this.els.slide.selector,
                defaultAnimation: {
                    duration: 1500,
                },
                loop: false,
                mode: 'snap',
                slides: {
                    perView: 1,
                },
                breakpoints: {
                    '(min-width: 768px)': {
                        slides: {
                            perView: 3,
                            spacing: 16,
                        },
                    },
                },
            },
            [
                setInitialised(),
                useArrows({
                    container: this.els?.arrows?.element,
                    next: this.els?.next?.element,
                    previous: this.els?.previous?.element,
                }),
                useCounter({
                    counter: this.els?.counter?.element,
                }),
                useProgress({
                    container: this.els?.progress?.element,
                    progressbar: this.els?.progressbar?.element,
                }),
            ],
        )
    }
}

if (!customElements.get('team-carousel')) {
    customElements.define('team-carousel', TeamCarousel)
}
